"use client";

import { motion } from "framer-motion";
import { Building2, Briefcase, GraduationCap, House as Home, Laptop, Server, Stethoscope, Store } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sectors = [{
  id: 1,
  name: "Luxury Homes",
  icon: Home
}, {
  id: 2,
  name: "Home Offices",
  icon: Laptop
}, {
  id: 3,
  name: "Server Rooms",
  icon: Server
}, {
  id: 4,
  name: "Hotels and Leisure",
  icon: Building2
}, {
  id: 5,
  name: "Offices",
  icon: Briefcase
}, {
  id: 6,
  name: "Medical",
  icon: Stethoscope
}, {
  id: 7,
  name: "Education",
  icon: GraduationCap
}, {
  id: 8,
  name: "Retail",
  icon: Store
}];
export default function SectorsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="sectorsgrid" className="bg-background py-16 md:py-24 overflow-hidden">
      <div ref={ref} className="container mx-auto px-4 md:px-6 max-w-6xl">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-6">
            Industries we work with
          </h2>
          <p className="text-muted-foreground max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
            Our installation, repair and maintenance services are suitable for a
            range of sectors and residential properties, including offices,
            shops, sports centres, homes, multi-story developments, large retail
            spaces, factories, and medical facilities. These include:
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {sectors.map((sector, i) => {
          const Icon = sector.icon;
          return <motion.div key={sector.id} data-index={i} initial={{
            opacity: 0,
            y: 20
          }} animate={isVisible ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: i * 0.1,
            ease: "easeOut"
          }} className="flex flex-col items-center">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-xl border-2 border-primary/20 transition-colors duration-300 flex items-center justify-center mb-5 bg-card shadow-sm">
                  <Icon className="w-10 h-10 md:w-12 md:h-12 text-primary/70 transition-colors duration-300 stroke-[1.5]" />
                </div>
                <h3 className="text-base md:text-lg font-default font-medium text-foreground text-center">
                  {sector.name}
                </h3>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8,
        ease: "easeOut"
      }} className="mt-16 md:mt-20 text-center space-y-6 border-t border-border pt-10">
          <p className="text-foreground max-w-4xl mx-auto text-base md:text-lg">Coastline Airconditioning provides expert air conditioning services across Sussex and Surrey.</p>
          
        </motion.div>
      </div>
    </section>;
}